const millionsPriceFormatter = (price: number) => `$${(price / 1000000).toFixed(2)}m`
const billionsPriceFormatter = (price: number) => `$${(price / 1000000000).toFixed(2)}b`
const percentFormatter = (price: number) => `${price.toFixed(2)}%`
const bitcoinPriceFormatter = (price: number) => `₿${price.toFixed(2)}`
const ethereumPriceFormatter = (price: number) => `Ξ${price.toFixed(2)}`
// round and 2nd decimal then format by millions $
const flowPrice = (price: number) => millionsPriceFormatter(Math.round(price * 100) / 100)

export const numberFormatters = {
    price: millionsPriceFormatter,
    percent: percentFormatter,
    largeNumber: billionsPriceFormatter,
    flowPrice: flowPrice,
    bitcoinPrice: bitcoinPriceFormatter,
    ethereumPrice: ethereumPriceFormatter
}